export const ANIMATED_ICONS = [
  {
    icon: 'star',
    color: '#005ED9',
    size: 15,
    position: { top: '2.52%', left: '-3.8%' },
    animationDuration: '2.2s',
  },
  {
    icon: 'star',
    color: '#208AA7',
    size: 12,
    position: { top: '6.31%', left: '1.16%' },
    animationDuration: '1.2s',
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 6,
    position: { top: '-3%', left: '12.21%' },
    animationDuration: '3s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 10,
    position: { bottom: '16.19%', right: '42.39%' },
    animationDuration: '2.2s',
  },
  {
    icon: 'star',
    color: '#005ED9',
    size: 13,
    position: { top: '12%', right: '2%' },
    animationDuration: '4s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 15,
    position: { top: '-3.7%', right: '12.21%' },
    animationDuration: '1.5s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 18,
    position: { bottom: '-4.7%', left: '-5%' },
    animationDuration: '1s',
  },
  {
    icon: 'star',
    color: '#1F9BBF',
    size: 15,
    position: { bottom: '7%', left: '3%' },
    animationDuration: '3s',
  },
  {
    icon: 'star',
    color: '#005ED9',
    size: 18,
    position: { bottom: '9%', right: '-5%' },
    animationDuration: '1.5s',
  },
  {
    icon: 'star',
    color: '#005ED9',
    size: 10,
    position: { bottom: '-4.7%', right: '5%' },
    animationDuration: '3s',
  },
  {
    icon: 'point',
    color: '#E7004F',
    size: 5,
    position: { bottom: '5%', right: '6%' },
    animationDuration: '2s',
  },
].map((props, key) => ({ ...props, key }));
